export const OPEN_PROFILE_MENU = '@@topbar/OPEN_PROFILE_MENU';
export const CLOSE_PROFILE_MENU = '@@topbar/CLOSE_PROFILE_MENU';
export const TOGGLE_PROFILE_MENU = '@@topbar/TOGGLE_PROFILE_MENU';

export const SHOW_NOTIFICATION = '@@topbar/SHOW_NOTIFICATION';
export const CLOSE_NOTIFICATION = '@@topbar/CLOSE_NOTIFICATION';
export const TOGGLE_NOTIFICATION = '@@topbar/TOGGLE_NOTIFICATION';

export const SHOW_SIDEBAR = '@@topbar/SHOW_SIDEBAR';
export const CLOSE_SIDEBAR = '@@topbar/HIDE_SIDEBAR';
export const TOGGLE_SIDEBAR = '@@topbar/TOGGLE_SIDEBAR';

export const CLOSE_ALL_MENU = '@@topbar/CLOSE_ALL_MENU';
export const SHOW_TOPBAR_MESSAGE = '@@topbar/SHOW_TOPBAR_MESSAGE';
export const CLOSE_TOPBAR_MESSAGE = '@@topbar/CLOSE_TOPBAR_MESSAGE';

export function showProfileMenu() {
  return { type: OPEN_PROFILE_MENU };
}

export function hideProfileMenu() {
  return { type: CLOSE_PROFILE_MENU };
}

export function toggleProfileMenu() {
  return { type: TOGGLE_PROFILE_MENU };
}

export function showNotificationMenu() {
  return { type: SHOW_NOTIFICATION };
}

export function hideNotificationMenu() {
  return { type: CLOSE_NOTIFICATION };
}

export function toggleNotificationMenu() {
  return { type: TOGGLE_NOTIFICATION };
}

export function showSidebarMenu() {
  return { type: SHOW_SIDEBAR };
}

export function hideSidebarMenu() {
  return { type: CLOSE_SIDEBAR };
}

export function toggleSidebarMenu() {
  return { type: TOGGLE_SIDEBAR };
}

export function closeAllMenu() {
  return { type: CLOSE_ALL_MENU };
}

export function showTopbarMessage(variant, message) {
  return {
    type: SHOW_TOPBAR_MESSAGE,
    variant: variant,
    message: message
  };
}

export function closeTopbarMessage() {
  return {
    type: CLOSE_TOPBAR_MESSAGE
  };
}
